import { getBackendBaseUrl } from './apiUtils';
import 'whatwg-fetch';

export const deeplinkApi = async (code: string): Promise<Response> => {
  const telehealthBaseURL = getBackendBaseUrl();
  const data = await fetch(`${telehealthBaseURL}/auth/join-code?code=${code}`, { method: 'POST' });
  return data;
};
